import Markdown from "../Markdown";
import { Display } from "../Icons";
import { styles } from "./styles";
import { ChatMessageProps } from "./types";
import { kitText } from "../../styles";

/**
 * `Chat.Message` represents a single message within a chat interface.
 * It can display content in either markdown or plain text format,
 * along with optional icons and bottom actions.
 */
function ChatMessage({
  content,
  icon,
  received,
  type = "markdown",
  children,
  bottomActions,
  attachments,
  attachmentsPosition = "top",
  title,
  titleIcon
}: ChatMessageProps) {
  const hasMessageContent =
    !!children ||
    (content !== undefined &&
      content !== null &&
      !(typeof content === "string" && content.trim() === ""));

  if (!attachments && !hasMessageContent) {
    return null;
  }

  return (
    <div
      className="kit-ChatMessage"
      css={[styles.message.base, received && styles.message.receivedBase]}
    >
      <div
        className="kit-chat-message-content-wrapper"
        css={[styles.message.contentWrapper]}
      >
        {title && (
          <div className="kit-chat-message-title" css={[styles.message.title]}>
            {titleIcon}
            <span css={kitText.style.bold}>{title}</span>
          </div>
        )}
        {attachmentsPosition === "top" && !!attachments && (
          <div
            className="kit-chat-message-attachments top"
            css={[styles.message.topAttachments]}
          >
            {attachments}
          </div>
        )}

        {hasMessageContent && (
          <div
            className="kit-chat-message-content"
            css={[
              styles.message.content,
              !received && styles.message.sentContent
            ]}
          >
            {!children && type === "markdown" && (
              <Markdown>{content as string}</Markdown>
            )}
            {!children &&
              type === "text" &&
              typeof content === "string" &&
              content}
            {children}
          </div>
        )}

        {attachmentsPosition === "bottom" && !!attachments && (
          <div
            className="kit-chat-message-attachments bottom"
            css={[styles.message.bottomAttachments]}
          >
            {attachments}
          </div>
        )}

        {!!bottomActions && (
          <div
            className="kit-chat-message-bottom-actions"
            css={styles.message.bottomActions}
          >
            {bottomActions}
          </div>
        )}
      </div>

      {icon && (
        <div className="kit-chat-message-icon" css={styles.message.icon}>
          <Display size="small">{icon}</Display>
        </div>
      )}
    </div>
  );
}

export default ChatMessage;
